import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { AlloyButton, AlloyIcon } from 'cat-ecommerce-alloy';
import WarningPopup from '@app/components/common/WarningPopup';
import styles from './styles.module.scss';

const ItemInOrderTableProp65Warning = ({ prop65Warning }) => {
  const [t] = useTranslation();

  const productWarningInitiator = (
    <AlloyButton
      buttonType="ghost"
      size="small"
      className={cx(
        'p-0 my-1 d-flex align-items-center text-lowercase text-sans-serif text-start d-print-none',
        styles['item-in-order-table-prop-65-warining__button']
      )}
    >
      <AlloyIcon icon="icon-warning-outline" className="me-2" />
      <span>{t('TABLE_PROP_65_WARNING')}</span>
    </AlloyButton>
  );

  return (
    <WarningPopup
      warnings={[
        {
          title: t('INACTIVITY_WARNING_DIALOG_WARNING_ICON'),
          message: prop65Warning
        }
      ]}
      initiator={productWarningInitiator}
    />
  );
};

ItemInOrderTableProp65Warning.propTypes = {
  prop65Warning: PropTypes.string
};

export default ItemInOrderTableProp65Warning;
